import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";

import { cn } from "../utils/styling";
import { Icon } from "./Icon";

export function Breadcrumb({ breadcrumbs }) {
  const breadcrumbsUrls = breadcrumbs
    ?.filter((breadcrumb) => breadcrumb.text)
    ?.map((breadcrumb) => ({
      text: breadcrumb.text,
      url: breadcrumb.url,
    }));

  const breadcrumbsLinks = breadcrumbsUrls?.map((url, index) => {
    const isLast = index === breadcrumbsUrls.length - 1;

    return (
      <Link key={index} to={url.url} underline="none">
        <span
          className={cn("font-ds-body-semibold-sm", isLast ? "text-lds-link-primary" : "text-lds-foreground-strong")}
        >
          {url.text}
        </span>
      </Link>
    );
  });

  return (
    <div className="[&_.MuiBreadcrumbs-separator]:mx-ds-0-25x">
      <Breadcrumbs aria-label="breadcrumb" separator={<Icon color="currentColor" iconName="ChevronRight" size="sm" />}>
        {breadcrumbsLinks}
      </Breadcrumbs>
    </div>
  );
}
